module.exports = __webpack_public_path__ + "img/slide3.b70fd298.png";